import { Component, OnInit, ViewChild } from '@angular/core';
import { PublisherModel } from './publisher-model';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { Local } from 'protractor/built/driverProviders';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';

declare var $;


@Component({
  selector: 'app-publisher-master',
  templateUrl: './publisher-master.component.html',
  styleUrls: ['./publisher-master.component.css']
})
/** publisher-master component*/
export class PublisherMasterComponent implements OnInit {

  modelItem = new PublisherModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  title: string;
  popupButtonText: string;
  showModal: boolean;
  CountryList: any;
  stageList: any;
  StateIDPop: number;
  CityidPop: number;
  CityList: any;
  journalType: any;
  platformList: any;
  StageList: any;
  styleList: any;
  PageLayoutList: any;
  CEIDList: any;
  BillingList: any;
  ProjectFromList: any;
  getJournals: any;
  file: any;
  fileBase64: any;
  Fileconfirmation: any;
  showNotesModal: boolean;
  FileName: any;
  NotesModalButton: string = "Submit"
  getSetOptions: any;
  journalFileTypeList: any;
  articleStageList: any;
  genfile: any;
  genfileBase64: any;
  GeneralNotesFile: any;

  ngOnInit() {
    $('#page-header-search-dropdown,.d-flex').hide();
    ApiMethod.getBaseUrl();
    $('#txtGeneralNotes').jqte();
    $('#divPrimary,#divsecondary,#divNotes').css({ 'height': (GlobalConstants.size.height - 260), 'resize': 'none' });

    $('#PublisherGeneralNotes .jqte_editor').css({ 'height': (GlobalConstants.size.height - 400), 'resize': 'none' });

  }

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <PublisherModel>data["PublisherPage"];


        $('#ddlJournalType').select2({
          placeholder: "Select JournalType",
          dropdownParent: "#divPrimary"
        });
        $('#ddlJournalType').val([]).trigger('change');

        $('#ddlStagesList').select2({
          placeholder: "Select Stages",
          dropdownParent: "#divsecondary"
        });
        $('#ddlStagesList').val([]).trigger('change');

        $("#lstPlatform").select2({
          placeholder: "Select Platform", dropdownParent: "#divsecondary"
        });
        $("#lstPlatform").val([]).trigger("change");

        $("#txtCEID").select2({
          placeholder: "Select ", dropdownParent: "#divsecondary"
        });
        $("#txtCEID").val([]).trigger("change");

        $("#txtPageLayoutID").select2({
          placeholder: "Select", dropdownParent: "#divsecondary"
        });
        $("#txtPageLayoutID").val([]).trigger("change");

        $("#txtProjectFromID").select2({
          placeholder: "Select", dropdownParent: "#divsecondary"
        });
        $("#txtProjectFromID").val([]).trigger("change");

        $("#txtBillingID").select2({
          placeholder: "Select", dropdownParent: "#divsecondary"
        });
        $("#txtBillingID").val([]).trigger("change");

        $("#StyleId").select2({
          placeholder: "Select", dropdownParent: "#divsecondary"
        });
        $("#StyleId").val([]).trigger("change");

        $('#ddlArticlestage').select2({
          placeholder: "Select ", dropdownParent: "#myModalnotes"
        });
        $('#ddlArticlestage').val([]).trigger('change');

        this.GetStagesList();
        this.GetPlatformList();
        this.GetPageLayoutList();
        this.GetRefStyleList();
        this.GetBillingTypeList();
        this.GetCE_PreEditList();
        this.GetProjectFromList();
        this.GetCountryList();
        this.GetPublisherData();
        this.GetJournalType();
        this.GetArticleStage();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  //Get All Countries list
  GetCountryList(): void {
    ApiMethod.getMethod(this.modelItem.CountryListAPI).subscribe(
      result => {
        this.CountryList = result.aCountryList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get State by Country
  GetState(StateID = 0, CityID = 0): void {
    ApiMethod.getMethod(this.modelItem.StateListAPI + $('#ddlCountry').val()).subscribe(
      result => {

        $("#ddlState").val(0).change();
        $("#ddlCity").val(0).change();

        this.stageList = result.aStateList;
        this.StateIDPop = StateID;
        if (CityID > 0) {
          this.GetCity(StateID, CityID);
          this.CityidPop = CityID;
        }


      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get City by State
  GetCity(StateID = 0, CityID = 0): void {
    let nstateId = $('#ddlState').val();
    if (nstateId == null) {
      nstateId = StateID;
    }

    ApiMethod.getMethod(this.modelItem.CityListAPI + nstateId).subscribe(
      result => {
        this.CityList = result.aCityList;
        this.CityidPop = CityID;
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get StagesList
  GetStagesList(): void {
    ApiMethod.getMethod(this.modelItem.StageListAPI).subscribe(
      result => {
        this.StageList = result.astageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetPlatformList(): void {
    ApiMethod.getMethod(this.modelItem.PlatFormListAPI).subscribe(
      result => {
        this.platformList = result.aplatformList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetPageLayoutList(): void {
    ApiMethod.getMethod(this.modelItem.PageLayoutListAPI).subscribe(
      result => {
        this.PageLayoutList = result.apagelayoutList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetRefStyleList(): void {
    ApiMethod.getMethod(this.modelItem.RefStyleListAPI).subscribe(
      result => {
        this.styleList = result.arefstyleList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetBillingTypeList(): void {
    ApiMethod.getMethod(this.modelItem.BillingTypeListAPI).subscribe(
      result => {
        this.BillingList = result.abillingtypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetCE_PreEditList(): void {
    ApiMethod.getMethod(this.modelItem.CE_PreEditListAPI).subscribe(
      result => {
        this.CEIDList = result.aCE_PreEditList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetProjectFromList(): void {
    ApiMethod.getMethod(this.modelItem.ProjectFromListAPI).subscribe(
      result => {
        this.ProjectFromList = result.aProjectFromList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get ArticleStagesList
  GetArticleStage(): void {
    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.GetArticleStageAPI + npublisherId).subscribe(
      result => {
        this.articleStageList = result.aArticleStageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //EmailID validation
  emailIdOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return ngswal("Warning !", "Invalid Email ID!", "warning");
    }
    return true;
  }

  //Multiple Email Id validation
  MultipleEmail(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      if (!filter.test(email)) {
        Worngmailcount++;
        continue;
      }
      else {
        validEmails.push(email);
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
  }

  //phone number validation
  numbervalidate(event): boolean {
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", "Number not valid", "warning");
    }
    return true;
  }

  //Get JournalType
  GetJournalType(): void {
    ApiMethod.getMethod(this.modelItem.JournalTypeListAPI).subscribe(
      result => {

        this.journalType = result.ajournalType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  onerrorImageLoad() {
    var zActHostpath = document.location.pathname.split('/')[1];
    $('#imgProfile').attr('src', '/' + zActHostpath + "../../../assets/Images/userLogo.jpg");
  }
  // showPreview Image Upload
  showPreview(event) {
    var ext = $('#imageUploadForm').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');

      ngswal("Failed !", "Invalid Image format", "warning");
      return false;
    }
    else if (event.target.files[0].size > 2000000) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
      ngswal("Failed !", "Please upload photo less than 2MB", "warning");
      return false;
    }
    if (event.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        $('#imgProfile').attr('src', fileReader.result);
      }
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }


  GetPublisherData(): void {

    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "PublisherModule"
    }
    ApiMethod.postMethod(this.modelItem.publisherListAPI, dataParam).subscribe(
      result => {


        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'PublisherModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Show Publisher details by ID
  showPublisher(): void {
    $("#btnPopupartDetails").show();
    this.ClearData();
    $("#tblAddPublisherNotes tbody").html("");
    if (localStorage.aEID != 0) {
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.PublisherByIDAPI + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;
          let publisherNotesList = result.aitemListNote;
         
          $('#Txt_PubTitle').val(aitems[0].PublisherTitle);
          $('#Txt_Acronym').val(aitems[0].PublisherName);
          $('#Txt_PubCode').val(aitems[0].PublisherCode);
          $('#Txt_RegCode').val(aitems[0].RegistrantCode);
          $('#Txt_Name').val(aitems[0].EmailID);
          $('#Txt_PhyEmail').val(aitems[0].PhysicsEmailId);
          $('#Txt_mobile').val(aitems[0].ContactNo);
          $('#ddlJournalType').val(aitems[0].JournalType);
          $('#Txt_address').val(aitems[0].Address);
          $('#Txt_ZipCode').val(aitems[0].ZIPPostCode);
          $('#Txt_RegionName').val(aitems[0].RegionName);
          $('#Txt_webaddress').val(aitems[0].WebAddress);
          $('#Txt_facsimile').val(aitems[0].Facsimile);
          $('#Txt_weblink').val(aitems[0].WebLink);
          $('#Txt_secretkey').val(aitems[0].Secretkey);
          $('#Txt_licensesubscription').val(aitems[0].License_Subscription);
          $('#Txt_licenseopenaccess').val(aitems[0].License_OpenAccess);
          $('#chkForceAllowIssueClosure').prop("checked", (aitems[0].ForceAllowIssueClousre));
          $("#ddlJournalType").val(aitems[0].JournalType).change();
          $("#lstPlatform").val(aitems[0].Platform).change();
          $("#StyleId").val(aitems[0].RefStyle).change();
          $("#txtCEID").val(aitems[0].CE_PreEdit).change();
          $("#txtBillingID").val(aitems[0].BillingType).change();
          $("#txtProjectFromID").val(aitems[0].ProjectFrom).change();
          $("#txtPageLayoutID").val(aitems[0].PageLayout).change();
          $('#PublisherGeneralNotes .jqte_editor').html(aitems[0].GeneralNotes);
          $("#Txt_AllocationPage").val(aitems[0].AllocationNTPageCount);
          $('#chkAutoBooking').prop("checked", (aitems[0].AutoBooking));
          //this.GeneralNotesFile = GlobalConstants.isNullCheck(aitems[0].GeneralUploadFile);
          if (GlobalConstants.isNullCheck(aitems[0].GeneralUploadFile) != "") {
            let notefile = GlobalConstants.isNullCheck(aitems[0].GeneralUploadFile).split('/');
            this.GeneralNotesFile = notefile[2].toString();
          }

          if (aitems[0].Logo == null)
            $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
          else
            $('#imgProfile').attr('src', aitems[0].Logo);


          $('#ddlCountry').val(aitems[0].Country).change();
          if ($('#ddlCountry').val() != null) {
            this.GetState(aitems[0].StateProvince, aitems[0].City);
          }

          //StagesList
          if (aitems[0].StageList != null) {

            let data = aitems[0].StageList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlStagesList').val(selectedValues).change();

          }


          $("#tblAddPublisherNotes tbody").html("");
          {
            if (publisherNotesList.length != 0) {

              var nRowL: "";
              for (var i = 0; i < publisherNotesList.length; i++) {
                if (publisherNotesList[i].UploadFileName != null) {
                  publisherNotesList[i].UploadFileName = publisherNotesList[i].UploadFileName.split('_').slice(0, -1).join('_');
                } else {
                  publisherNotesList[i].UploadFileName = "_"
                }
                nRowL += "<tr id='trJnotes_" + (i + 1).toString() + "'>";
                nRowL += "<td>" + (i + 1).toString() + "</td>";
                nRowL += "<td>" + publisherNotesList[i].StageName + "</td>";
                nRowL += "<td>" + publisherNotesList[i].Description + "</td>";
                //if (publisherNotesList[i].UploadFileName != '') {
                //  nRowL += "<td style='text-align: center'><i class='bx bxs-download' style='color: blue; font-size: 20px;cursor:Pointer;' onclick=localStorage.aStageEID='" + publisherNotesList[i].Id + "';$('#btnDwnldjNotes').trigger('click');></i></td>";
                //}
                //else {
                //  nRowL += "<td style='text-align: center'></td>";
                //}
                /* nRowL += "<td onclick=localStorage.aStageEID='" + publisherNotesList[i].Id + "';$('#btnDwnldjNotes').trigger('click'); style='cursor: pointer !important; color: #556ee6 !important; text-decoration: underline;width: auto !important;'>" + publisherNotesList[i].UploadFileName + "</td>";*/
                nRowL += "<td style='text-align: center'>";
                nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.aStageEID='" + publisherNotesList[i].Id + "';$('#spAddPublisherNotes').trigger('click');></i>&nbsp;";
                nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.aStageEID='" + publisherNotesList[i].Id + "';$('#btnDeletePublisherNotes').trigger('click');></i>"
                if (publisherNotesList[i].UploadFileName != '') {
                  nRowL += "<i class='bx bx-download' style='font-size: 20px !important;cursor: pointer !important;color: #556ee6;padding: 2px;' onclick=localStorage.aStageEID='" + publisherNotesList[i].Id + "';$('#btnDwnldjNotes').trigger('click');></i></td>";
                }
                nRowL += "</td>";

                nRowL += "</tr>";
              }

              $("#tblAddPublisherNotes tbody").append(nRowL);
            }
          }

        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.popupButtonText = "Update";
    } else this.popupButtonText = "Save";
    this.title = "Publisher Details";
  }

  //Update Publisher details
  UpdatePublisher(): void {
    if ($('#Txt_Acronym').val() == '') {
      ngswal("Warning !", "Enter Publisher name!", "warning");
    }
    else if ($('#Txt_PubTitle').val() == '') {
      ngswal("Warning !", "Enter Publisher Title!", "warning");
    }
    else if ($('#Txt_PubCode').val() == '') {
      ngswal("Warning !", "Enter Publisher Code!", "warning");
    }
    else if ($('#Txt_RegCode').val() == '') {
      ngswal("Warning !", "Enter Registrant Code!", "warning");
    }
    else if ($('#Txt_Name').val() == '') {
      ngswal("Warning !", "Enter Email!", "warning");
    }
    else if ($('#Txt_PhyEmail').val() == '') {
      ngswal("Warning !", "Enter Physics Email", "warning");
    }
    else if ($('#Txt_mobile').val() == '') {
      ngswal("Warning !", "Enter Contact No", "warning");
    }
    else if ($('#ddlJournalType').val() == '') {
      ngswal("Warning !", "Enter Journal Type", "warning");
    }
    else if ($('#Txt_address').val() == '') {
      ngswal("Warning !", "Enter Address", "warning");
    }
    else if ($('#Txt_ZipCode').val() == '') {
      ngswal("Warning !", "Enter Zip Code", "warning");
    }
    else if ($('#Txt_RegionName').val() == '') {
      ngswal("Warning !", "Enter Region Name", "warning");
    }

    else {
      $("#LoadingImagePopup").show();
      let fileName = null; let fileSize = null;
      if (this.genfile != null) {
        fileName = this.genfile.name;
        fileSize = this.genfile.size
      }
      var publisherData = {
        ID: localStorage.aEID,
        PublisherCode: $('#Txt_PubCode').val(),
        PublisherName: $('#Txt_Acronym').val(),
        PublisherTitle: $('#Txt_PubTitle').val(),
        RegistrantCode: $('#Txt_RegCode').val(),
        EmailID: $('#Txt_Name').val(),
        PhysicsEmailId: $('#Txt_PhyEmail').val(),
        ContactNo: $('#Txt_mobile').val(),
        JournalType: $('#ddlJournalType').val(),
        Address: $('#Txt_address').val(),
        ZIPPostCode: $('#Txt_ZipCode').val(),
        RegionName: $('#Txt_RegionName').val(),
        Logo: $('#imgProfile').attr('src'),
        WebAddress: $('#Txt_webaddress').val(),
        Facsimile: $('#Txt_facsimile').val(),
        WebLink: $('#Txt_weblink').val(),
        PageLayout: $('#txtPageLayoutID').val(),
        CE_PreEdit: $('#txtCEID').val(),
        RefStyle: $('#StyleId').val(),
        ProjectFrom: $('#txtProjectFromID').val(),
        BillingType: $('#txtBillingID').val(),
        Platform: $('#lstPlatform').val(),
        StageList: $("#ddlStagesList").val().toString(),
        Secretkey: $('#Txt_secretkey').val(),
        License_Subscription: $('#Txt_licensesubscription').val(),
        License_OpenAccess: $('#Txt_licenseopenaccess').val(),
        ForceAllowIssueClousre: $('#chkForceAllowIssueClosure').prop('checked'),
        Country: $('#ddlCountry').val(),
        StateProvince: $('#ddlState').val(),
        City: $('#ddlCity').val(),
        GeneralNotes: $('#txtGeneralNotes').val(),
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.genfileBase64,
        UpdatedBy: localStorage.aLoginID,
        AllocationNTPageCount: $("#Txt_AllocationPage").val(),
        AutoBooking: $('#chkAutoBooking').prop('checked')
      };

      ApiMethod.postMethod(this.modelItem.UpdateAPI, publisherData).subscribe(
        resonse => {
          this.GetPublisherData();
          $("#LoadingImagePopup").hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: resonse,
            showConfirmButton: false,
            timer: 1500
          });
          this.hide();
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }


  ClearData(): void {
    $("input[type='text']").val("");
    $("input[type='number']").val("");
    $("input[type='email']").val("");
    $("textarea").val("");
    $("input[type='checkbox']").prop("checked", false);
    $("#Txt_AllocationPage").val("");
    $("#ddlCountry").val(0).change();
    $("#ddlState").val(0).change();
    $("#ddlCity").val(0).change();
    $("#ddlJournalType").val(0).change();
    $("#ddlStagesList").val(0).change();
    $("#lstPlatform").val(0).change();
    $("#txtBillingID").val(0).change();
    $("#txtProjectFromID").val(0).change();
    $("#StyleId").val(0).change();
    $("#txtCEID").val(0).change();
    $("#txtPageLayoutID").val(0).change();
    $("#txtGeneralNotes").val("");
    $("#PublisherNotesDescription").val("");
    $("#ddlArticlestage").val(0).change();

    //file field
    $("#gendoc_uploadfile").val("");
    this.file = null;
    this.fileBase64 = null;

    $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
    $("#imageUploadForm").val(null);
  }
  hide(): void {
    $("#btnPopupartDetails").hide();
    $('#ULTabul a[href="#divPrimary"]').trigger('click');
  }


  // file delete confirmation notes 
  Deleteconfirmation() {
    ngswal({
      title: "Are You Confirm to delete Publisher Notes?",
      text: "Publisher Notes deleted Permanently..!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnDeletePublisherNote').trigger("click");
        } else {
          return false;
        }
      });
  };

  deletePublisherNotes() {
    $("#LoadingImagePopup").show();
    ApiMethod.getMethod(this.modelItem.DeletePublisherNotesByID + "/" + localStorage.aStageEID).subscribe(
      Response => {
        this.hide();
        this.getJournals();
        if (Response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: Response.message,
            showConfirmButton: true,
          });
        } else {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Failed !",
            text: Response.message,
            showConfirmButton: true,
          });
        }

        $("#LoadingImagePopup").hide();
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }

  DownloadPublisherNotes(type = 'stage') {
    let aEid = localStorage.aStageEID;
    if (type == 'main') {
      aEid = localStorage.aEID;
    }
    ApiMethod.Downloadfile(this.modelItem.PublisherNotesDownloadFilesAPI + '/' + type + '/' + aEid);
  }

  onuploadSelected(fileInput: any) {
    var ext = $('#doc_uploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf', 'zip', 'xlsx']) == -1) {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50KB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
          console.log(this.fileBase64);
        }

        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  GeneralUploadSelected(fileInput: any) {
    var ext = $('#gendoc_uploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf', 'zip', 'xlsx', 'xls']) == -1) {
      $('#gendoc_uploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#gendoc_uploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50KB", "warning");
      return;
    } else {
      this.genfile = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.genfileBase64 = null;
          this.genfileBase64 = e.currentTarget.result;
          console.log(this.fileBase64);
        }

        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  hideNotes() {
    this.showNotesModal = false;
    this.clearPublisherNotes();
    localStorage.aEID = 0;
    localStorage.aStageEID = 0;
  }

  clearPublisherNotes() {
    $("#ddlArticlestage").val(0).change();
    $("#PublisherNotesDescription").val("");
    $("#doc_uploadfile").val("");
    $(".UploadFile").show();
    $(".btnRemovefile").hide();
    $('#btndownloadPublisherNotes').hide();
  }
  //show publisher notes info
  showPublisherNotes() {
    this.showNotesModal = true;
    this.clearPublisherNotes();
    this.fileBase64 = null;
    this.file = null;
    $('#container').hide();
    if (localStorage.aStageEID != 0) {
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.ShowPublisherNotesByID + '/' + localStorage.aStageEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;
          $('#PublisherNotesDescription').val(aitems[0].Description);
          $("#ddlArticlestage").val(aitems[0].StageName).change();
          this.FileName = aitems[0].UploadFileName.split('_').slice(0, -1).join('_');

          if (aitems[0].UploadFileName != null) {
            $(".UploadFile").show();
            $('#btndownloadPublisherNotes').show();
          }
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.NotesModalButton = "Update";
    } else {
      this.NotesModalButton = "Save";
      this.title = "Update Notes";
      $(".btnRemovefile").hide();
    }
  }



  addUpdateNotes() {
    if
      ($('#PublisherNotesDescription').val() == '') {
      ngswal("Warning !", "Enter Description  !", "warning");
    }
    else if ($('#ddlArticlestage').val() == null) {
      ngswal("Warning !", "Select Type!", "warning");
    }

    else {
      //$("#LoadingImagenotes").show();
      let fileName = null; let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size
      }
      var JournalNotes = {

        Description: $('#PublisherNotesDescription').val(),
        StageName: $('#ddlArticlestage').val(),
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        PublisherIId: localStorage.aEID,
        Id: localStorage.aStageEID
      };

      ApiMethod.postMethod(this.modelItem.PublisherNotesByIDAPI, JournalNotes).subscribe(
        result => {
          this.showNotesModal = false;
          if (result.status == 'Success') {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Updated !",
              text: result.message,
              showConfirmButton: true,
            });
            this.hide();
            this.getSetOptions();
          }
          $("#LoadingImagenotes").hide();
        }, error => {
          ngswal("Failed!", error.Message, "error");
          $("#LoadingImagenotes").hide();
        }
      );

    }

  }
}

